var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCheckList(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M14.34 -0.000198364H5.67C2.28 -0.000198364 0 2.3798 0 5.9198V14.0898C0 17.6198 2.28 19.9998 5.67 19.9998H14.34C17.73 19.9998 20 17.6198 20 14.0898V5.9198C20 2.3798 17.73 -0.000198364 14.34 -0.000198364Z",
    fill: "#FF9900"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.81295 13.2479C8.58895 13.2479 8.36495 13.1629 8.19395 12.9919L5.82095 10.6189C5.47895 10.2769 5.47895 9.7229 5.82095 9.3819C6.16295 9.0399 6.71595 9.0389 7.05795 9.3809L8.81295 11.1359L12.941 7.0079C13.283 6.6659 13.836 6.6659 14.178 7.0079C14.52 7.3499 14.52 7.9039 14.178 8.2459L9.43195 12.9919C9.26095 13.1629 9.03695 13.2479 8.81295 13.2479Z",
    fill: "#FF9900"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckList);
export default __webpack_public_path__ + "static/media/checkList.820109d727ffe1acc30fbdb2d03bc749.svg";
export { ForwardRef as ReactComponent };